import { useContext } from "react";
import { ThemeContext } from "../common/themeContext";
import { isHealthcareAiCampaignComingSoon } from "../common/permissions";

export const useHealthcareCampaignComingSoon = () => {
  const { brandId } = useContext(ThemeContext);
  return isHealthcareAiCampaignComingSoon(brandId);
};
